module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/pui-react-lists/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 3215
// module chunks = 0